export type FormatVideoTimecodeValueParams = {
  value: number;
};

export const formatVideoTimecodeValue = ({ value }: FormatVideoTimecodeValueParams) => {
  return String(value).padStart(2, '0');
};
